import type { TextProps as _HelpTextProps } from "@chakra-ui/react";
import { forwardRef, FormHelperText as _FormHelperText } from "@chakra-ui/react";

export interface FormHelpTextProps extends _HelpTextProps {}

export const FormHelperText = forwardRef<FormHelpTextProps, "p">(({ ...props }, ref) => (
    <_FormHelperText ref={ref} as="p" {...props} />
));
